unable to read source [project]/node_modules/stripe/src/net/FetchHttpClient.ts